const Promotion = () => {

    return (
        <div className="image-wrapper">
            <img className="image" src="/img/promotion/43_1.jpg" alt="" />
            <a href="https://www.google.com/maps/d/edit?hl=ko&mid=1gh2VGZ9Yz_a-YuGmYRkoKOy6zLMw2UWv&ll=33.375780898712776%2C126.5543311&z=11"
               target="_blank"><img className="image" src="/img/promotion/43_2.jpg" alt="" /></a>
        </div>
    )
}
export default Promotion;
